export const commonSentryConfig = {
  dsn: 'https://8d0f4b845aa04c3ba402a58b80d828ec@o1064019.ingest.us.sentry.io/6054571',

  ignoreErrors: [
    // user has wrong device time
    /Časová značka události je v budoucnosti/,
    /Twilsock: request timeout/,
  ],

  // Drop errors that originate from known 3rd party sources we don't control
  denyUrls: [
    // Browser extensions (all major browsers)
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    /^safari-extension:\/\//i,
    /^safari-web-extension:\/\//i,
  ],

  enabled: process.env.NODE_ENV !== 'development',

  // 10% of transactions in production — start low and increase based on observed traffic.
  tracesSampleRate: 0.1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,
}
